module.exports = __webpack_public_path__ + "media/images/common/guidace_character-3747ce584b0013283d52394c9649475a.png";